export const base64ImageBlob = (base64Image) => {
    const base64Content = base64Image.split(',')[1];
    const binaryString = window.atob(base64Content);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: base64Image.split(':')[1].split(';')[0] });
}
export const base64VideoBlob = (base64Video) => {
    const base64Content = base64Video.split(',')[1];
    const binaryString = window.atob(base64Content);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    const mimeType = base64Video.split(':')[1].split(';')[0];
    return new Blob([bytes], { type: mimeType });
}